import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle } from '@material-ui/core';
import React, { useState } from 'react';
import { ExtendedRadioGroup } from 'framework/components/ExtendedRadioGroup';
import { useLocalization } from 'localization/useLocalization';

interface IProps extends DialogProps {
	cancel: VoidFunction;
	confirm: (isAdd: boolean) => void;
}

export const AddOrCreateForm = ({ cancel, confirm, ...rest }: IProps) => {
	const strings = useLocalization();
	const [isAdd, setIsAdd] = useState<boolean>(true);

	return (
		<Dialog {...rest}>
			<DialogTitle>{`${strings.repair}, ${strings.makeAChoice}`}</DialogTitle>
			<DialogContent dividers>
				<ExtendedRadioGroup<boolean>
					selected={isAdd}
					setSelected={setIsAdd}
					options={[
						{ value: true, label: strings.addToExistingRepair, caption: strings.addToExistingRepairCaption },
						{ value: false, label: strings.registerANewRepair, caption: strings.registerANewRepairCaption },
					]}
				/>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={cancel}
					color='primary'>
					{strings.cancel}
				</Button>
				<Button
					onClick={() => confirm(isAdd)}
					color='primary'>
					{strings.select}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
